export const handleNavigationClick = (
  id: string,
  headerHeight: number,
  isMobile: boolean
): void => {
  if (!window) return;

  const section = document.getElementById(id);
  const headerOffset = isMobile ? 0 : headerHeight;

  if (section) {
    const sectionPosition = section.offsetTop;
    const offsetPosition = sectionPosition - headerOffset;

    window.scroll({
      top: offsetPosition,
      behavior: 'smooth',
    });

    window.setTimeout(() => {
      if (sectionPosition !== section.offsetTop) {
        window.scroll({
          top: section.offsetTop - headerOffset,
          behavior: 'smooth',
        });
      }
    }, 1000);
  }
};
